module.exports = __webpack_public_path__ + "static/media/office8.4a4d9d7a.jpg";